



























































































  /* eslint-disable no-console */

  import Vue from 'vue'
  import _ from 'lodash'
import { Component, Watch } from 'vue-property-decorator'
import {CatalogueMatchDTO, EditionDTO, TextFragmentDataDTO} from '@/dtos/sqe-dtos'

declare class col {
    id: number
    name: string
}

@Component
export default class TextSelector extends Vue {
    dialog = false
    selectedCol: col = {} as col
    cols: TextFragmentDataDTO[] = []
    images: CatalogueMatchDTO[] = []

    get textFragment(){
        return this.selectedCol
    }

    set textFragment(newVal: col) {
      this.$store.commit('col_idSet', newVal.id)
      this.$store.commit('colInfoSet', newVal.name)
      this.getTextFragmentImagedObjects(newVal.id)
    }

    get edition(): EditionDTO{
      return this.$store.state.selectedEdition
    }

    set edition(newVal: EditionDTO){
      this.$store.commit('selectedEditionSet', newVal)
      this.$store.commit('scroll_idSet', newVal.id)
      this.$store.commit('manuscript_nameSet', newVal.name)
    }

    async getTextFragmentImagedObjects(id: number){
      try {
        const res = await this.$com.sqeComms?.getV1CatalogueTextFragmentsTextFragmentIdImagedObjects(id)
        if (res)
          this.images = _.uniqBy(res.matches, (x) => [x.imagedObjectId, x.catalogSide].join()).sort((a, b) => `${a.imagedObjectId}-${a.catalogSide}`.localeCompare(`${b.imagedObjectId}-${b.catalogSide}`))
      } catch(err) {
        console.error(err)
      }
    }

    async getTextFragments() {
      if(this.$store.state.selectedEdition.id) {
        try {
          const res = await this.$com.sqeComms?.getV1EditionsEditionIdTextFragments(this.$store.state.selectedEdition.id)
          this.cols = res!.textFragments
        } catch(err) {
          console.error(err)
        }
      }
    }

    selectImage(image:CatalogueMatchDTO) {
        this.dialog = false
        this.$store.commit('image_catalog_idSet', image.imagedObjectId)
        this.$store.commit('imageInfoSet', `${image.institution} ${image.catalogueNumber1}.${image.catalogueNumber2} (${image.catalogSide})`)
        this.$store.commit('imageSideSet', image.catalogSide?.toString())
    }

    @Watch('$store.state.selectedEdition')
    async editionIdChanged(newVal: EditionDTO, oldVal: EditionDTO) {
        if (newVal !== oldVal) {
          await this.getTextFragments()
          this.selectedCol = {id: this.$store.state.col_id, name: this.$store.state.colInfo}
        }
    }

    @Watch('$store.state.col_id')
    textFragmentIdChanged(newVal: number, oldVal: number) {
        if (newVal !== this.selectedCol.id) {
            this.selectedCol = {id: this.$store.state.col_id, name: this.$store.state.colInfo}
            this.getTextFragmentImagedObjects(newVal)
        }
    }
}
